module.exports = function(focus) {
	"use strict";
  focus
  .directive('autoCompleteDir',autoCompleteDir);
	autoCompleteDir.$inject = ['$timeout','getDataService','$compile','refreshtokenService','serverError','alertService','keyPress','jQuery', 'postDataService', 'offlineError'];
  function autoCompleteDir($timeout,getDataService,$compile, refreshtokenService,serverError,alertService,keyPress,jQuery, postDataService, offlineError) {
    return {
      scope:{
        datachangelabel:'=',
        datachangeid:'=',
        currentTag: '=',
        typeDir:'=',
        enterTag:'&'
      },
      require: 'ngModel',
      link: function(scope, element, attrs, ngModel) {
        var s;
        var html = angular.element(document.getElementById('template.html')).html();
        element.after($compile(html)(scope));
        scope.showDropdown = false;
        var index = -1;
        scope.autocompleteView = true; 
        scope.chooseSearchData = function(dataName,dataId, dataUrl) {
          ngModel.$setViewValue(dataName);
          element.val(dataName);
          scope.showDropdown = false;
          scope.activeTag = false;
          scope.datachangelabel = dataName;
          scope.datachangeid = dataId;
          scope.tagsTree = [];
          if(scope.typeDir == 'insertTag') {
            scope.selectedTagObj = {
              tagUrl: dataUrl
            }
          } else {
            scope.selectedTagObj = {
              tagId:dataId,
              tagName:dataName,
              tagUrl: dataUrl
            }
          }
          // element.focus();
          // scope.enterTag();
          if(scope.typeDir == 'insertTag') {
            scope.$emit('editor-select-tag', {selectedTagObj:scope.selectedTagObj});
          } else if(scope.typeDir=='insertTagRecomendedNews') {
            scope.$emit('recommended-news-select-tag', {selectedTagObj:scope.selectedTagObj});
          } else {
            scope.$emit('select-tag', {selectedTagObj:scope.selectedTagObj});
          }
        };
        function mouseDown(e) {
          if(!scope.autocompleteView) return;
          if(angular.element(document.getElementsByClassName("autocomplete-result"))) {
          var container = angular.element(document.getElementsByClassName("autocomplete-result"));
          var serch_input = angular.element(document.getElementsByClassName("search-autocomplete"));
          if (!container.is(e.target) // if the target of the click isn't the container...
            && container.has(e.target).length === 0 && scope.showDropdown && !serch_input.is(e.target) && serch_input.has(e.target).length===0 && !element.is(e.target)) // ... nor a descendant of the container
          {
            scope.$apply(function () {
              if(!scope.activeTag && scope.typeDir=='menu') {
                ngModel.$setViewValue(null);
                element.val(null);
              }
              scope.showDropdown = false;
              scope.tagsTree = [];
              index= -1;
            });
          }}
        }
        angular.element(document).on('mousedown', mouseDown);
        element.on('keydown', function(event) {
          if(scope.showResult) {
            if(event.which === 40) {
              if(index >=scope.tagsTree.length-1) {
                index = -1
              }
              index++
              for(var i=0; i<scope.tagsTree.length;i++) {
                 scope.$apply(function () {
                  scope.tagsTree[i].active = false;
                 })
                if(index==i) {
                  scope.$apply(function () {
                    scope.tagsTree[index].active = true;
                  });  
                }
              }
            } else if(event.which === 38) {
              if(index <= 0) {
                index=scope.tagsTree.length
              }
              index--
              for(var i=0; i<scope.tagsTree.length;i++) {
                 scope.$apply(function () {
                  scope.tagsTree[i].active = false;
                 })
                if(index==i) {
                  scope.$apply(function () {
                    scope.tagsTree[index].active = true;
                  });  
                }
              }
            }
          }
        });
        element.on('keypress', function(event) {
          // scope.showDropdown = false; 
          if(event.which === 13) {
            scope.activeTag = false;
            if(scope.tagsTree && scope.tagsTree.length>0) {
              for(var i=0; i<scope.tagsTree.length;i++) {
                if(scope.tagsTree[i].active) {
                  $timeout(function() {
                    scope.chooseSearchData(scope.tagsTree[i].name,scope.tagsTree[i]._id, scope.tagsTree[i].url);
                  },0)
                  scope.activeTag = true;
                  return 
                }
              }
            }
            if(!scope.activeTag) {
              if(scope.typeDir =='focus') {
                  scope.$apply(function () {
                  ngModel.$setViewValue(null);
                  element.val(null);
                  scope.showDropdown = false;
                  scope.activeTag = false;
                  scope.datachangelabel = null;
                  scope.datachangeid = null;
                })
              } else if(scope.typeDir =='menu'){
                scope.$apply(function () {
                  ngModel.$setViewValue(null);
                  element.val(null);
                  scope.showDropdown = false;
                  scope.activeTag = false;
                })
              } else {
                if(scope.typeDir !='insertTag' && scope.typeDir !='mergeTag' && scope.typeDir !='catalogTag' && scope.typeDir!='insertTagRecomendedNews') {
                  scope.$apply(function () {
                    scope.enterTag();
                    scope.showDropdown = false;
                  })
                }
              }
            }
          }
          keyPress(event);
        });
        var getFunction = function(type) {
          getDataService.get({param1:(type=='video')? 'video-tags':(type=="catalogTag")?'catalogs':'tags',param2:(type=="catalogTag")?'tags':undefined, param3:'search', s:ngModel.$viewValue}).$promise.then(function(data){
            if(!ngModel.$viewValue || ngModel.$viewValue.length<2) return;
            index = -1;
            scope.tagsTree = data.tags;
            scope.tagsTree = scope.tagsTree.slice(0,30);
            if(scope.tagsTree.length > 0) {
              scope.showResult = true;
              for(var i=0; i<scope.tagsTree.length;i++) {
                scope.tagsTree[i].active = false;
              }
              if(scope.typeDir == 'focus' || scope.typeDir=='menu') {
                scope.tagsTree[0].active = true;
                index= 0;
              }
            } else {
              scope.showResult = false;
            }
            scope.showDropdown = true;
          }, function(error){
            if(!window.navigator.onLine) {
              offlineError()
              scope.showDropdown =false;
              index= -1;
              return
            }
            if(error.status == 401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
              function(answer) {
                if(answer==200) {
                  getFunction(type);
                }
                // do something
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
              });
            } else if(error.status ==502) {
              serverError()
            } else {
              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
            }  
          });
        }
        if(scope.typeDir == 'insertTag') {
          setTimeout(function(){
            getFunction(scope.typeDir)
          },0)
        }
        element.on('keyup', function(event) {
          if(ngModel.$viewValue && ngModel.$viewValue.length >=2) {
            if(event.which != 38 && event.which != 40 && event.which != 13) {
              getFunction(scope.typeDir);
            }
          } else {
            scope.$apply(function () {
              scope.showDropdown =false;
              index= -1;
            })
          }
        });
        scope.$on('$destroy', function() {
          scope.autocompleteView = null;
          angular.element(document).off('mousedown', mouseDown);
        })
      }
    };
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/autoCompleteDirective.js
// module id = 432
// module chunks = 0